import Axios, { AxiosResponse } from "axios";
import { apiUrl } from "constants/defaultValues";

const axios = Axios.create({
    baseURL: apiUrl,
});

axios.interceptors.request.use(function (config) {
    const authToken = localStorage.getItem("Gamesfi_Current_User");
    if (authToken) {
        config.headers.authorization = authToken;
    }
    config.headers.Accept = 'application/json';
    return config;
});

// axios.interceptors.response.use(
//     (response): any => {
//         return response.data;
//     },
// );
export default axios;